// Curated taxonomy deduplicated from Yelp, HomeAdvisor, and Angi.
// Top-level "groups" render on the landing page. Sub-items appear in
// the Directory category dropdown only.
export const TAXONOMY = [
  {
    group: "Home Services",
    items: [
      "Plumbing", "Electrical", "HVAC & Heating", "Roofing", "Painting",
      "Flooring", "Handyman", "Pest Control", "Appliance Repair",
      "Small Engine Repair",
      "Locksmiths", "Drywall", "Insulation", "Foundation Repair",
      "Garage Door Services", "Junk Removal", "Window Installation",
      "Pool Service", "Pool Repair", "Pool Builder", "Pool Tile Cleaning",
      "Pool Remodeling", "Pool Store",
      "Outdoor Lighting", "Pet Waste Removal", "Pressure Washing", "Garbage Can Cleaning",
    ],
  },
  {
    group: "Apparel & Gifts",
    items: [
      "DTF Printing", "DTG Printing", "Sublimation", "Vinyl",
      "Embroidery", "Laser Engraving",
    ],
  },
  {
    group: "Cleaning",
    items: [
      "House Cleaning", "Carpet Cleaning", "Window Washing",
      "Pressure Washing", "Office Cleaning", "Move-in/Move-out Cleaning",
    ],
  },
  {
    group: "Landscaping & Outdoor",
    items: [
      "Lawn Care", "Tree Services", "Irrigation", "Fencing",
      "Decks & Patios", "Snow Removal", "Concrete & Masonry",
    ],
  },
  {
    group: "Construction & Remodeling",
    items: [
      "General Contractors", "Kitchen Remodel", "Bathroom Remodel",
      "Additions", "Basement Finishing", "Tiling", "Cabinetry",
      "Architects",
    ],
  },
  {
    group: "Moving & Storage",
    items: ["Local Movers", "Long-distance Movers", "Packing Services", "Storage Units"],
  },
  {
    group: "Auto Services",
    items: [
      "Auto Repair", "Body Shops", "Tires", "Oil Change Stations",
      "Car Wash", "Car Detailing", "Towing", "Auto Glass Services",
      "Auto Parts", "Motorcycle Repair", "RV Repair",
    ],
  },
  {
    group: "Food & Drink",
    items: [
      "Restaurants", "Cafés & Coffee", "Bakeries", "Bars", "Breweries",
      "Caterers", "Food Trucks", "Ice Cream & Frozen Yogurt",
      "Juice Bars", "Specialty Food",
    ],
  },
  {
    group: "Beauty & Spas",
    items: [
      "Hair Salons", "Barbers", "Nail Salons", "Skin Care",
      "Massage", "Day Spas", "Tattoo & Piercing", "Makeup Artists",
      "Eyelash Service",
    ],
  },
  {
    group: "Health & Medical",
    items: [
      "Doctors", "Dentists", "Chiropractors", "Physical Therapy",
      "Optometrists", "Mental Health", "Pharmacy", "Urgent Care",
      "Acupuncture", "Dermatology",
    ],
  },
  {
    group: "Fitness",
    items: [
      "Gyms", "Yoga Studios", "Pilates", "Martial Arts",
      "Personal Trainers", "Crossfit", "Dance Studios", "Climbing",
    ],
  },
  {
    group: "Pets",
    items: ["Veterinarians", "Pet Grooming", "Pet Boarding", "Dog Walkers", "Pet Training", "Pet Stores"],
  },
  {
    group: "Professional Services",
    items: [
      "Accountants", "Tax Services", "Lawyers", "Insurance",
      "Notary Services", "Marketing", "Web Designers", "IT Services",
      "Bookkeeping", "Translation Services",
    ],
  },
  {
    group: "Real Estate",
    items: ["Real Estate Agents", "Property Management", "Mortgage Brokers", "Home Inspectors", "Apartments"],
  },
  {
    group: "Financial Services",
    items: ["Banks & Credit Unions", "Financial Advising", "Investing", "Check Cashing", "ATMs"],
  },
  {
    group: "Education & Tutoring",
    items: ["Tutors", "Test Prep", "Music Lessons", "Language Schools", "Driving Schools", "Childcare", "Preschools"],
  },
  {
    group: "Events & Weddings",
    items: ["Wedding Planning", "Venues", "Photographers", "Videographers", "DJs", "Florists", "Party Rentals", "Catering"],
  },
  {
    group: "Shopping",
    items: [
      "Grocery", "Clothing", "Bookstores", "Electronics", "Furniture",
      "Home Decor", "Toys", "Jewelry", "Sporting Goods", "Thrift Stores",
      "Antiques", "Eyewear", "Dispensaries", "Auctions", "Liquidators",
      "Pop-Up Shops",
    ],
  },
  {
    group: "Arts & Entertainment",
    items: ["Movie Theaters", "Museums", "Music Venues", "Art Galleries", "Bowling", "Arcades", "Escape Rooms"],
  },
  {
    group: "Nightlife",
    items: ["Lounges", "Cocktail Bars", "Sports Bars", "Dance Clubs", "Karaoke", "Pubs"],
  },
  {
    group: "Hotels & Travel",
    items: ["Hotels", "Bed & Breakfast", "Vacation Rentals", "Travel Agents", "Car Rental", "Airport Shuttles"],
  },
  {
    group: "Local Services",
    items: ["Dry Cleaning", "Tailors", "Shoe Repair", "Watch Repair", "Couriers", "Printing Services", "Recycling Center"],
  },
  {
    group: "Childcare & Family",
    items: ["Daycare", "Nannies", "Babysitters", "After-school Programs", "Summer Camps"],
  },
  {
    group: "Religious & Community",
    items: ["Churches", "Mosques", "Synagogues", "Community Centers", "Non-profits"],
  },
  {
    group: "Technology",
    items: ["Computer Repair", "Phone Repair", "Software Development", "Networking", "Smart Home Installation"],
  },
  {
    group: "Senior & Disability",
    items: ["Senior Care", "Home Health Aides", "Hospice", "Assisted Living", "Accessibility Modifications"],
  },
];

export const TOP_LEVEL_CATEGORIES = TAXONOMY.map((t) => t.group);

export function findGroupForCategory(leaf) {
  for (const t of TAXONOMY) {
    if (t.group === leaf) return leaf;
    if (t.items.includes(leaf)) return t.group;
  }
  return null;
}

// Flat list of every category for autocomplete / select
export const ALL_CATEGORIES = (() => {
  const set = new Set();
  for (const t of TAXONOMY) {
    set.add(t.group);
    t.items.forEach((i) => set.add(i));
  }
  return Array.from(set).sort();
})();
